import { GridCellProps } from "@progress/kendo-react-grid"
import React from "react"
import { useAppDispatch } from "../../../../../app/hooks"
import { toggleCarveOutEditModal } from "../../../../../app/slices/ContractModuleSlice";
import { GridButton } from "../../../../../components"

function CarveOutEditCommandCell(props:GridCellProps){
    const dispatch = useAppDispatch();

    return <React.Fragment>
        <GridButton size='small' onClick={()=>dispatch(toggleCarveOutEditModal(props.dataItem.id))}>View</GridButton>
    </React.Fragment>
}

export {CarveOutEditCommandCell}